import * as searchSuggestion from './searchSuggestion'
import Swal from 'sweetalert2';

export const handleSearch = async (data, setSearchValue, setDataLoaded, get_node_by_id) => {
    setDataLoaded(null)
    var input_element = document.getElementById('search_bar_input');
    var newSearchValue = input_element.value;
    var searchSuggestions = searchSuggestion.getSearchSuggestions(newSearchValue, data);
    
    if (searchSuggestions.length > 0) {
        var searchObject = searchSuggestions[0]
        setSearchValue(searchObject);
        get_node_by_id(searchObject.id)
        let clear_btn = document.getElementById("search_bar_clear")
        if (newSearchValue != "") {
            clear_btn.style.display = 'block';
        } else {
            clear_btn.style.display = 'none';
        }
    } else {
        Swal.fire({
            icon: 'error',
            title: 'No entries match your search',
            text: "Try modifying your search",
        });
        console.log("No entries matching the search")
        
    }
    setTimeout(function(){
        setDataLoaded(true)
    }, 0);

}

export const clear_search = (setSearchValue) => {
    setSearchValue("");
    searchSuggestion.toggleSearchSuggestions(false);
}

export const updateSearchBar = (content) => {
    let searchBar = document.getElementById("search_bar_input")
    searchBar.value = content
    searchSuggestion.toggleSearchSuggestions(false);
  }